// hooks/useDemoModeNavigation.js
import { useNavigate } from "react-router-dom";
import {
  incrementCustomerCount,
  shouldShowModal,
} from "../../utils/nudgeCounter";
import { isDemoMode } from "../../utils/demoEnviornment";

/**
 * Custom hook for handling navigation logic with demo-mode awareness.
 * Can be reused across all components.
 */
export const useDemoModeNavigation = () => {
  const navigate = useNavigate();

  /**
   * Handles navigation and modal logic for demo mode.
   *
   * @param {string} type - The type of action (e.g. "transaction", "invoice", "stock", "customer")
   * @param {string} route - The route to navigate to (e.g. `/Accounts/AccountDetail/${id}`)
   * @param {object} [extraState={}] - Additional state to pass to navigation
   * @param {number} [delay=800] - Optional delay for non-demo users (ms)
   */
  const handleDemoNavigation = (type, route, extraState = {}, delay ) => {
    if (isDemoMode()) {
      const count = incrementCustomerCount(type);

      const showModal = shouldShowModal(type);

      navigate(route, {
        replace: true, // avoids stacking navigation history
        state: { showDemoModal: showModal, ...extraState },
      });
    } else {
      delay
        ? setTimeout(
            () =>
              navigate(route, {
                replace: true,
                state: { ...extraState },
              }),
            delay
          )
        : navigate(route, {
            replace: true,
            state: { ...extraState },
          });
    }
  };

  return { handleDemoNavigation };
};
